<template>

<section class="premium-section">

<h2 class="section-title">Creator Reward Model</h2>

<p>

The Mudra platform introduces a structured reward model designed to recognize and reward creators for producing original written content. Unlike traditional content platforms that rely heavily on engagement metrics such as likes, views, or advertisements, the Mudra ecosystem focuses on rewarding the act of creation itself.

</p>

<p>

The reward system is designed to ensure fairness, transparency, and sustainability within the ecosystem. By combining platform-level content verification with blockchain-based token distribution, Mudra creates a system where creators receive clear and predictable rewards for their contributions.

</p>


<h3 class="section-subtitle">Reward Categories</h3>

<p>

To support different forms of creative writing, the Mudra platform categorizes content into multiple types based on length and structure. Each category has a predefined reward value that reflects the effort required to produce that type of content.

</p>


<!-- Reward Boxes -->

<div class="reward-grid">

<div class="reward-box">
<h4>Poetry</h4>
<p class="reward-amount">0.10 MDR</p>
<p class="reward-words">Minimum 30 Words</p>
</div>

<div class="reward-box">
<h4>Poem</h4>
<p class="reward-amount">0.20 MDR</p>
<p class="reward-words">Minimum 70 Words</p>
</div>

<div class="reward-box">
<h4>Short Story</h4>
<p class="reward-amount">0.50 MDR</p>
<p class="reward-words">Minimum 500 Words</p>
</div>

<div class="reward-box">
<h4>Long Story</h4>
<p class="reward-amount">1.00 MDR</p>
<p class="reward-words">Minimum 1000+ Words</p>
</div>

</div>


<h3 class="section-subtitle">Content Quality Standards</h3>

<p>

To ensure that rewards are distributed fairly, submitted content must meet certain quality and originality standards. The platform evaluates submissions using a combination of automated analysis and manual moderation processes.

</p>

<p>

Content that fails to meet originality requirements or violates platform guidelines may be rejected or removed from the reward pool. This mechanism helps maintain a high-quality creative environment within the Mudra ecosystem.

</p>


<h3 class="section-subtitle">Reward Distribution Mechanism</h3>

<p>

Once content has been verified and approved by the platform, the creator becomes eligible to receive Mudra Tokens as rewards. The reward allocation is calculated based on the category of content submitted and the predefined reward model.

</p>

<p>

Instead of distributing tokens instantly, the Mudra platform utilizes a vesting-based reward mechanism. This ensures long-term stability within the ecosystem while preventing sudden token supply shocks.

</p>


<h3 class="section-subtitle">Fairness and Transparency</h3>

<p>

The reward model is designed to operate transparently within the blockchain ecosystem. All token distributions are handled through smart contracts deployed on the Polygon network, allowing users to independently verify reward transactions on the blockchain.

</p>

<p>

This transparent model ensures that creators receive rewards according to predefined rules rather than relying on opaque algorithms or centralized decision-making processes.

</p>


<h3 class="section-subtitle">Encouraging Creative Participation</h3>

<p>

The primary goal of the Mudra reward system is to encourage meaningful creative participation. By providing a predictable and transparent reward structure, the platform motivates creators to contribute original work and actively participate in the growth of the ecosystem.

</p>

<p>

As the Mudra community expands, the reward system may evolve to include additional incentives, community-driven initiatives, and new content formats that support the long-term sustainability of the platform.

</p>

</section>

</template>



<style scoped>

/* Reward Grid */

.reward-grid{
display:grid;
grid-template-columns:repeat(auto-fit,minmax(200px,1fr));
gap:18px;
margin-top:20px;
}

/* Reward Box */

.reward-box{
background:rgba(0,234,255,0.05);
border:1px solid rgba(0,234,255,0.25);
border-radius:10px;
padding:18px;
text-align:center;
transition:0.25s;
}

/* Hover Effect */

.reward-box:hover{
background:rgba(0,234,255,0.08);
transform:translateY(-3px);
}

/* Title */

.reward-box h4{
color:#00eaff;
font-size:18px;
margin-bottom:6px;
}

/* Reward Amount */

.reward-amount{
font-size:20px;
font-weight:700;
margin-bottom:4px;
}

/* Word Limit */

.reward-words{
font-size:14px;
color:#ccefff;
}

</style>